import { TransportManagementSearchCriteria } from '../models';

export class TransportManagementTransportOrderLoad {
  public static readonly type = '[ManagementTransportOrder] Load';
  constructor(public payload: TransportManagementSearchCriteria) {}
}

export class TransportManagementTransportOrderInitialState {
  public static readonly type = '[ManagementTransportOrder] Set Initial State';
}
